import PropTypes from 'prop-types';
import {
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';

import {
  LeafletPolygon,
  useLeafletMap,
  useLeafletMapEvent,
} from '../leaflet';

function PxMapRadarActions(props) {
  const {
    allReady = false,
    mapConfig,
    zoomBounds,
  } = props;

  const map = useLeafletMap();
  const displayBounds = useRef([
    [mapConfig.latS, mapConfig.lngW],
    [mapConfig.latN, mapConfig.lngE]]);

  const zoomPolygon = useMemo(
    () => {
      if (zoomBounds) {
        const [[zoomLatS, zoomLngW], [zoomLatN, zoomLngE]] = zoomBounds;
        return [
          [zoomLatS, zoomLngW],
          [zoomLatS, zoomLngE],
          [zoomLatN, zoomLngE],
          [zoomLatN, zoomLngW],
        ];
      }

      return null;
    },
    [zoomBounds],
  );

  //
  // Zoom around town bounds when all is ready
  //
  useEffect(
    () => {
      if (map && allReady) {
        map.invalidateSize({ animate: false });
        map.fitBounds(displayBounds.current);
      // debugger
      }
    },
    [map, allReady],
  );

  //
  // Propagate zoom info outside
  //
  const setDisplayBounds = useCallback(
    (newBounds) => {
      displayBounds.current = newBounds;
    },
    [],
  );

  const handleZoomEnd = useCallback(
    () => {
      if (map) {
        // // console.log(`zoom=${map.getZoom()} ${displayJson(map, 2)}`);
        // mapZoom.current = map.getZoom();
        const newBounds = map.getBounds();
        displayBounds.current = [
          [newBounds._southWest.lat, newBounds._southWest.lng],
          [newBounds._northEast.lat, newBounds._northEast.lng],
        ];
      }
    },
    [map],
  );

  useLeafletMapEvent(
    'zoomend',
    handleZoomEnd,
  );

  const handleMoveEnd = useCallback(
    () => {
      if (map) {
      // console.log(`zoom=${map.getZoom()} ${displayJson(map, 2)}`);
        const newBounds = map.getBounds();
        setDisplayBounds([
          [newBounds._southWest.lat, newBounds._southWest.lng],
          [newBounds._northEast.lat, newBounds._northEast.lng],
        ]);
      }
    },
    [map, setDisplayBounds],
  );

  useLeafletMapEvent(
    'moveend',
    handleMoveEnd,
  );

  if (zoomPolygon) {
    return (
      <LeafletPolygon
        positions={zoomPolygon}
        pathOptions={{
          // edge:
          color: '#FF0000',
          opacity: 1,
          weight: 1,
          // body:
          fillColor: '#FFFFFF',
          fillOpacity: '0.15',
        }}
      />
    );
  }

  return null;
}

PxMapRadarActions.propTypes = {
  allReady: PropTypes.bool,
  mapConfig: PropTypes.shape({
    latN: PropTypes.number,
    latS: PropTypes.number,
    lngW: PropTypes.number,
    lngE: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  zoomBounds: PropTypes.arrayOf(PropTypes.shape),
};

export default PxMapRadarActions;
